import { render, staticRenderFns } from "./ContaConfiguracaoTela.vue?vue&type=template&id=009601ae&scoped=true&"
import script from "./ContaConfiguracaoTela.vue?vue&type=script&lang=js&"
export * from "./ContaConfiguracaoTela.vue?vue&type=script&lang=js&"
import style0 from "./ContaConfiguracaoTela.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ContaConfiguracaoTela.vue?vue&type=style&index=1&id=009601ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009601ae",
  null
  
)

export default component.exports